import { createActions, createReducer } from 'reduxsauce';

// types
const { Types, Creators } = createActions({
  fetchMenus: [],
  fetchMenusSuccess: ['data'],
  fetchMenusFailure: [],
  resetMenus: [],
});

const INITIAL_STATE = {
  loading: false,
  data: [],
};

// reducers
const fetch = (state = INITIAL_STATE) => ({ ...state, loading: true });

const fetchSuccess = (state, { data }) => ({ data, loading: false });

const fetchFailure = (state = INITIAL_STATE) => ({ ...state, loading: false });

const reset = () => INITIAL_STATE;

// Hookup reducers to types
const Reducers = createReducer(INITIAL_STATE, {
  [Types.FETCH_MENUS]: fetch,
  [Types.FETCH_MENUS_SUCCESS]: fetchSuccess,
  [Types.FETCH_MENUS_FAILURE]: fetchFailure,
  [Types.RESET_MENUS]: reset,
});

export { Reducers, Types, Creators };
export default Reducers;
